  import React from "react";
  import Slider from "react-slick";
  import Image from "next/image";

  export default function HeroCarousel() {
    // Slider configuration
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
    };

    // Slides with image + banner text
    const slides = [
      {
        image: "/images/mens/Banner-Carosols-without-text.png",
        text: "Elegance Tailored Just for You",
      },
      {
        image: "/images/srk-image2.png",
        text: "Where Tradition Meets Style",
      },
      { 
        image: "/images/womens/womens-banner1.png",
        text: "Exclusive Designer ",
      },
      { 
        image: "/images/srk-image6.png",
        text: "Exclusive Designer Wear",
      },
      { 
        image: "/images/womens/womens-banner.png",
        text: "Exclusive Designer",
      }

    ];

    return (
      <div className="relative">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div
              key={index}
              className="relative w-full aspect-[16/9] md:h-[75vh] md:aspect-auto max-h-[800px] overflow-hidden"
            >
              {/* Full-screen responsive image */}
              <Image
                src={slide.image}
                alt={slide.text || `Slide ${index + 1}`}
                fill
                sizes="100vw"
                style={{
                  objectFit: "cover",
                  objectPosition: "center top",
                }}
                priority={index === 0}
              />

              {/* Overlay to improve text contrast */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />

              {/* Centered banner text */}
              <div className="absolute inset-0 flex items-center justify-center text-center px-4 pt-24 sm:pt-16 md:pt-0">
                <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-bold leading-tight">
                  {slide.text}
                </h1>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }